import React, { useEffect, useState } from "react";
import { EyeOutlined } from "@ant-design/icons";
import { Button, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { formatDate } from "../../../utils/dateFormatter";
import { ErrorToast } from "../../../widgets/AppToast";

const VoyageListing = () => {
  const navigate = useNavigate();
  const [ship_id, set_ship_id] = useState("");
  const [loader, set_loader] = useState(true);
  const [ship_table_list, set_ship_table_list] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const SHIP_LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          VOYAGE_LIST_API(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  const VOYAGE_LIST_API = (shipId) => {
    set_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", shipId);
    try {
      post(ApiURL.list_voyage_info_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.voyage);
          set_loader(false);
        } else {
          ErrorToast("Error Message", res?.response?.data?.message);
        }
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
    } finally {
    }
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      align: "center",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Role",
      dataIndex: "role",
      align: "center",
      key: "role",
    },
    {
      title: "Vessel Name",
      dataIndex: "ship_name",
      align: "center",
      key: "ship_name",
    },
    {
      title: "Voyage No",
      dataIndex: "voyage_no",
      align: "center",
      key: "voyage_no",
    },
    {
      title: "Voyage Type",
      dataIndex: "voyage_type",
      align: "center",
      key: "voyage_type",
    },
 
    {
      title: "Voyage Status",
      dataIndex: "voyage_status",
      align: "center",
      key: "voyage_status",
      render: (text, record) => {
        if (record.voyage_status) {
          return <span className="table-status-running">Running</span>;
        } else {
          return <span className="table-status-completed">Completed</span>;
        }
      },
    },
    {
      title: "Created Date",
      dataIndex: "created_date",
      align: "center",
      key: "created_date",
      render: (text, record) => formatDate(record?.voyage_date),
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <Tooltip title="View Voyage">
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(`/voyage-view/${btoa(record.id)}`)}
            style={{ marginRight: "15px" }}
            icon={<EyeOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <div>
        <div className="row">
          <div className="col-3">
            <label className="block-label">Select Ship</label>
            <Select
              placeholder="---- Select Ship ----"
              style={{ width: "100%" }}
              value={ship_id}
              onChange={(value) => {
                set_ship_id(value);
                VOYAGE_LIST_API(value);
              }}
            >
              {ship_table_list?.length > 0 && (
                <>
                  {ship_table_list.map((ship) => (
                    <>
                      {!ship.soft_delete && (
                        <>
                          <Select.Option key={ship.id} value={ship.id}>
                            {ship.vessel_name}
                          </Select.Option>
                        </>
                      )}
                    </>
                  ))}
                </>
              )}
            </Select>
          </div>
        </div>

        <div className="row" style={{ padding: "10px" }}>
          <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
            <div className="theme-content-title text-left">
              <h3>Voyage List</h3>
            </div>
          </div>
          <div className="col-3"></div>
          <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="d-flex align-items-center">
              <Button
                type="primary"
                className="save_btn"
                onClick={() => navigate("/view-audit-trail-voyage")}
              >
                Audit Trail
              </Button>
            </div>
          </div>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          loading={loader}
          className="custom-table"
        />
      </div>
    </>
  );
};

export default VoyageListing;
